import React from 'react';
import { CTAButton } from './CTAButton';
import { plans } from '../data/content';
type PricingSectionProps = {
  id: string;
  compact?: boolean;
  dark?: boolean;
};
export function PricingSection({
  id,
  compact = false,
  dark = false
}: PricingSectionProps) {
  return <section id={id} className={`w-full scroll-mt-4 px-4 py-8 sm:px-6 sm:py-12 ${dark ? 'bg-ink-900' : 'bg-ink-800'}`} data-id="element-135" data-mp="1j8yth5hv3sqd">
      <div className="mx-auto max-w-3xl text-center" data-id="element-136" data-mp="1n9r4o4aao7pa">
        <h2 className="text-xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-137" data-mp="1s9dh4biatjx1">
          Elegí tu sistema
        </h2>

        <div className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-138" data-mp="1x8ginlz2l809">
          {plans.map(plan => <article key={plan.name} className={`relative flex flex-col rounded-xl border p-4 text-left sm:p-5 ${plan.featured ? 'border-gold-500 bg-ink-700 shadow-[0_0_32px_rgba(232,184,0,0.18)]' : 'border-white/10 bg-ink-700'}`} data-id="element-139" data-mp="2282y822df0c8">
              <h3 className="pr-2 text-sm font-extrabold uppercase leading-snug text-white sm:text-base" data-id="element-140" data-mp="1mhzjje2y8nd1">
                <span aria-hidden="true" data-id="element-141" data-mp="1hnv92kuh5x77">{plan.icon}</span> {plan.name}
              </h3>

              {!compact && <>
                  <p className="mt-1.5 text-[13px] font-semibold text-gold-400" data-id="element-142" data-mp="17sabr00cpl3s">
                    {plan.includes}
                  </p>
                  <p className="mt-1 text-[13px] text-neutral-400" data-id="element-143" data-mp="25f0qv5jz6zk5">
                    <span className="font-semibold text-white" data-id="element-144" data-mp="20g68u5tu1f13">
                      Ideal para:
                    </span>{' '}
                    {plan.idealFor}
                  </p>
                </>}

              <p className="mt-3 flex items-baseline gap-2" data-id="element-145" data-mp="1rezr5tfg5y69">
                {!compact && <span className="text-[13px] font-semibold text-neutral-500 line-through" data-id="element-146" data-mp="k2z7h8jsl8kw">
                    {plan.oldPrice}
                  </span>}
                <span className="text-2xl font-extrabold text-gold-500 sm:text-3xl" data-id="element-147" data-mp="hh8d9nfwclca">
                  {plan.price}
                </span>
              </p>

              <div className="mt-auto pt-4" data-id="element-148" data-mp="meryx8exc0e9">
                <CTAButton href={plan.href} variant={plan.featured ? 'primary' : 'outline'} data-id="element-149" data-mp="7kdd703z6cvw">
                  {plan.cta}
                </CTAButton>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}